/* sb-dc-tplshrink.js - stop template text from being clipped, by fitting the
   TEXT to the box instead of the box to the text. 2026-09-12 (v5).

   Reported: a step & repeat template shows "VOTE 2026" on the Design Templates
   page and "VOT" / "202" on the artboard.

   MEASURED: layer "VOTE" fontSizeIn 4.92, bold Archivo, widthIn 11.84, while
   bold Archivo measures 2.769 em for "VOTE" -> 13.62in needed. The box came
   from the <text> advance in the source SVG, written with the designer's font;
   the artboard redraws with the webfont it loaded, which is wider.

   WHY NOT JUST WIDEN THE BOX: that was sb-dc-tplwidth.js, and it lost. The app
   owns text box sizing (__dcFitAll / __dcFitUpd / __dcOnTextFit) and put the
   narrow width straight back - 600 writes over 39 rounds in 20s. So leave the
   box alone and make the glyphs fit it.

   ROTATED TEXT IS LEFT ALONE - twice over, and both matter.
     v4 stopped SHRINKING rotated layers. sb-dc-tplrot.js puts a -90 back on
     vertical text and swaps the box's width and height to match; measuring the
     glyph run against what is now the short side is meaningless, and it was
     shrinking perfectly good text.
     v5 also stops WATCHING them. The settle test below treats any change as a
     reason to wait, so every angle tplrot applied reset this file's timer,
     which delayed its `settled` flag, which is what tplrot now waits for
     before it may use its short rule. The two were holding each other up:
     measured, the gate did not open until 16.5s. Rotated layers are none of
     this file's business in either direction.

   GUARDS, because the app may push back here too:
     - shrink only, never grow;
     - FLOOR: never below 75% of the size the template asked for;
     - MAX_PER_LAYER attempts, then leave that layer alone and name it in
       __dcTplShrink().stuck.

   Diagnostics: window.__dcTplShrink() */
(function () {
  'use strict';

  var TICK = 250, WINDOW_MS = 40000, SETTLE = 1, QUIET = 3;
  var MARGIN = 0.98, FLOOR = 0.75, MIN_DROP = 0.01, MAX_PER_LAYER = 3;

  var info = { rounds: 0, waits: 0, settled: false, skippedFont: 0,
               skippedRot: 0, floored: 0, stuck: [], shrunk: 0, why: '' };
  window.__dcTplShrink = function () { return info; };

  function q(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }
  if (!q('tpl')) { info.why = 'no tpl'; info.settled = true; return; }

  var tries = {}, base = {}, ctx = null;

  function mine(l) {
    return l && l.type === 'text' && !+l.curveDeg && !+l.rotation;
  }

  function emWidth(l) {
    if (!ctx) ctx = document.createElement('canvas').getContext('2d');
    var fam = l.fontFamily || 'Archivo';
    var font = (l.italic ? 'italic ' : '') + (l.bold ? '700 ' : '400 ') + '100px "' + fam + '"';
    try {
      if (document.fonts && document.fonts.check && !document.fonts.check(font)) {
        info.skippedFont++;
        return 0;
      }
    } catch (e) {}
    ctx.font = font;
    var em = 0, lines = String(l.text == null ? '' : l.text).split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var w = ctx.measureText(lines[i]).width / 100;
      if (w > em) em = w;
    }
    return em * (+l.stretchX || 1);
  }

  function pass(api, side) {
    if (window.SBDC914?.host.handled(api[side])) return;
    var sd = api[side];
    if (!sd || !Array.isArray(sd.layers)) return 0;
    var n = 0;
    sd.layers.forEach(function (l) {
      if (!l || l.type !== 'text') return;
      if (!mine(l)) { if (+l.rotation) info.skippedRot++; return; }
      if (tries[l.id] >= MAX_PER_LAYER) return;

      var fs = +l.fontSizeIn || 0, box = +l.widthIn || 0;
      if (!fs || !box) return;
      if (base[l.id] == null) base[l.id] = fs;

      var em = emWidth(l);
      if (!em) return;

      var fits = box * (window.__dcFitBox ? 1 : MARGIN) / em;
      if (fs - fits < fs * MIN_DROP) return;     // already fits

      var floor = base[l.id] * FLOOR;
      if (fits < floor) { fits = floor; info.floored++; }
      if (fs - fits < fs * MIN_DROP) return;

      tries[l.id] = (tries[l.id] || 0) + 1;
      if (tries[l.id] >= MAX_PER_LAYER && info.stuck.length < 8) info.stuck.push(l.id);

      api.updateLayer(l.id, { fontSizeIn: fits });
      info.shrunk++;
      n++;
    });
    return n;
  }

  /* Only the layers this file may touch. A rotated layer changing is
     sb-dc-tplrot.js doing its job, not a reason for us to keep waiting. */
  function sigOf(api) {
    var out = '';
    ['front', 'back'].forEach(function (side) {
      var sd = api[side];
      if (!sd || !Array.isArray(sd.layers)) return;
      sd.layers.forEach(function (l) {
        if (!mine(l)) return;
        out += '|' + l.id + ',' + (+l.xIn).toFixed(2) + ',' + (+l.widthIn).toFixed(2)
             + ',' + (+l.fontSizeIn).toFixed(2) + ',' + String(l.text).length;
      });
    });
    return out;
  }

  var t0 = Date.now(), sig = null, same = 0, quiet = 0;
  var t = setInterval(function () {
    if (Date.now() - t0 > WINDOW_MS) { info.settled = true; clearInterval(t); return; }
    var api = window.__dcApi;
    if (!api || !api.front || typeof api.updateLayer !== 'function') return;

    var s = sigOf(api);
    if (s !== sig) { sig = s; same = 0; info.waits++; info.settled = false; return; }
    if (++same < SETTLE) return;
    same = 0;

    var n = 0;
    try {
      n += pass(api, 'front');
      if (api.back && api.back.layers && api.back.layers.length) n += pass(api, 'back');
    } catch (e) { info.why = 'error: ' + (e && e.message); }

    if (n) { info.rounds++; quiet = 0; sig = null; info.settled = false; }
    else if (++quiet >= QUIET) info.settled = true;
  }, TICK);
})();
